//
//
//
//

export default {
  name: 'consult',
  data () {
    return {}
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/components/consult.vue